module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a2bf4b67c31465785acd31bbdadbcc9c.png";